/* eslint react-hooks/exhaustive-deps: "warn" */

import cn from 'classnames';

import { Badge } from 'ui/atoms/Badge/Badge';
import { Icon } from 'ui/atoms/Icon/Icon';

import styles from './BankVerificationCard.module.scss';

import type { BankVerificationCardProps } from './BankVerificationCard.types';

export const BankVerificationCard = ({ className }: BankVerificationCardProps) => (
  <div className={cn(styles.card, className)}>
    <div className={styles.top}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          <div className={styles.iconWrap}>
            <Icon type="payg-63" size="big" className={styles.bankIcon} />
          </div>

          <span className={styles.cardTitle}>Bank Account Verification</span>
        </div>

        <div className={styles.headerRight}>
          <Badge size="sm" variant="default">
            API
          </Badge>
          <Badge size="sm" variant="primary">
            Dashboard
          </Badge>
        </div>
      </div>

      <div className={styles.fields}>
        <div className={styles.fieldsRow}>
          <div className={styles.fieldItem}>
            <span className={styles.fieldLabel}>IBAN / Account Number</span>
            <span className={styles.fieldValue}>GB29 NWBK 6016 1331 9268 19</span>
          </div>

          <div className={styles.fieldItem}>
            <span className={styles.fieldLabel}>Sort Code</span>
            <span className={styles.fieldValue}>60–16–13</span>
          </div>
        </div>

        <div className={styles.fieldsRow}>
          <div className={styles.fieldItem}>
            <span className={styles.fieldLabel}>Payee Name</span>
            <span className={styles.fieldValue}>Acme Trading Ltd</span>
          </div>

          <div className={styles.fieldItem}>
            <span className={styles.fieldLabel}>SWIFT / BIC</span>
            <span className={styles.fieldValue}>NWBKGB2L</span>
          </div>
        </div>
      </div>

      <div className={styles.verifyBtn}>Verify Account</div>
    </div>

    <div className={styles.bottom}>
      <div className={styles.resultHeader}>
        <span className={styles.resultIcon}>
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" aria-hidden="true">
            <circle cx="10" cy="10" r="10" fill="#36b38f" className={styles.checkCircle} />
            <path
              d="M6 10L8.5 12.5L14 7"
              stroke="white"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
              className={styles.checkPath}
            />
          </svg>
        </span>

        <span className={styles.resultTitle}>Verified — Account Ownership Confirmed</span>
        <span className={styles.resultTime}>187ms</span>
      </div>

      <div className={styles.resultItems}>
        <div className={cn(styles.resultItem, styles.resultItemGreen)}>
          <span className={styles.resultItemLabel}>IBAN Status</span>

          <div className={styles.resultItemValue}>
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" aria-hidden="true">
              <path
                d="M2 6L4.5 8.5L10 3.5"
                stroke="#36b38f"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>

            <span className={styles.resultItemValueText}>Valid</span>
          </div>
        </div>

        <div className={cn(styles.resultItem, styles.resultItemGreen)}>
          <span className={styles.resultItemLabel}>Name Match</span>
          <span className={styles.resultItemValueText}>Exact — 97%</span>
        </div>

        <div className={cn(styles.resultItem, styles.resultItemGrey)}>
          <span className={styles.resultItemLabel}>Bank</span>
          <span className={styles.resultItemValueText}>NatWest (UK)</span>
        </div>
      </div>
    </div>
  </div>
);
